exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-link-editor-form.ng-invalid.ng-untouched .mdl-textfield .mdl-textfield__input {\n  border-color: inherit;\n}\n\n.common-link-editor-form.ng-invalid.ng-untouched .mdl-textfield .mdl-textfield__label {\n  color: inherit;\n}\n\n", ""]);

// exports
